import type { ReactNode } from 'react';

/**
 * A toggle pill for the multi-select fields: skills, available days, time
 * slots and work types. `aria-pressed` carries the state to assistive tech.
 */
export function ChoiceChip({
  selected,
  onToggle,
  disabled,
  children,
}: {
  selected: boolean;
  onToggle: () => void;
  disabled?: boolean;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={selected}
      className={`rounded-full border px-3.5 py-1.5 text-xs font-semibold transition duration-200 ease-out disabled:cursor-not-allowed disabled:opacity-40 ${
        selected
          ? 'border-brand-600 bg-brand-600 text-white shadow-soft'
          : 'border-line bg-white text-slate-600 hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700'
      }`}
    >
      {children}
    </button>
  );
}
